export default __webpack_public_path__ + "static/scene-three-21c330792ba9fdee07a5bf33065ff72e.svg";